// 由 EB view/admin/src/router/modules/cms.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const cmsRouter: RouteRecordRaw =
    {
      path: `${roterPre}/cms`,
      name: 'cms',
      meta: {
        icon: 'dashboard',
        title: '内容'
      },
      alwaysShow: true,
      component: Layout,
      children: [
        {
          path: 'article',
          name: 'article',
          meta: {
            title: '文章管理',
            noCache: true
          },
          component: () => import('@/views/cms/article/index.vue')
        },
        {
          path: 'articleCategory',
          name: 'articleCategory',
          meta: {
            title: '文章分类',
            noCache: true
          },
          component: () => import('@/views/cms/articleCategory/index.vue')
        },
        {
          path: 'article/addArticle/:id?',
          component: () => import('@/views/cms/addArticle/index.vue'),
          name: 'EditArticle',
          meta: { title: '文章添加', noCache: true, activeMenu: '/cms/article' },
          hidden: true
        }
      ]
    }

export default cmsRouter;
